
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/databricks",
      function () {
        return require("private-next-pages/destinations/databricks.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/databricks"])
      });
    }
  